import type { LookbackOption, FilterOption } from './types';

export const POLLING_INTERVAL_MS = 30000;

export const LOOKBACK_OPTIONS: LookbackOption[] = [
  { id: '1', label: 'Last 1 hour' },
  { id: '6', label: 'Last 6 hours' },
  { id: '24', label: 'Last 24 hours' },
  { id: '48', label: 'Last 48 hours' },
  { id: '72', label: 'Last 72 hours' },
  { id: '168', label: 'Last 7 days' },
  { id: '720', label: 'Last 30 days' },
];

export const STATUS_OPTIONS: FilterOption[] = [
  { id: 'all', label: 'All Statuses' },
  { id: 'not_started', label: 'Pending' },
  { id: 'in_progress', label: 'Running' },
  { id: 'complete', label: 'Completed' },
  { id: 'failed', label: 'Failed' },
];

export const TRIGGER_TYPE_OPTIONS: FilterOption[] = [
  { id: 'all', label: 'All Trigger Types' },
  { id: 'on_demand', label: 'On Demand' },
  { id: 'geometry_update', label: 'Geometry Update' },
  { id: 'new_well', label: 'New Well' },
  { id: 'backfill', label: 'Backfill' },
];

export const TRIGGER_TYPE_LABELS: Record<string, string> = {
  on_demand: 'On Demand',
  geometry_update: 'Geometry Update',
  new_well: 'New Well',
  backfill: 'Backfill',
};

// Shared with the agent-costs dashboard and the Eval 3 run spinner — see utils/duration.
export { formatDuration } from 'utils/duration';
